export type TenantPortalConfig = {
  apiBaseUrl: string;
  authority: string;
  clientId: string;
  scope: string;
};

const defaultScope =
  "openid profile email urn:zitadel:iam:org:project:id:374211792286516002:aud";

export const config: TenantPortalConfig = {
  apiBaseUrl: import.meta.env.VITE_EVOBUDDY_API_BASE_URL ?? "https://api.evobuddy.com",
  authority: import.meta.env.VITE_ZITADEL_AUTHORITY ?? "https://auth.evobuddy.com",
  clientId: import.meta.env.VITE_ZITADEL_CLIENT_ID ?? "374774780726870818",
  scope: import.meta.env.VITE_ZITADEL_SCOPE ?? defaultScope,
};
